<template>
  <div>
    <!--fkey要配置不重複的值,避免多個populateForm用同樣的配置欄位設定配出相同dom id出來-->
    <!--collapseStyle不是空字串就會有header,至於設定值對應的內涵尚未設計-->
    <populate-form
      formTitle="快速建立預設內定預約的預約排程"
      fkey="sm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="formDataObj"
      :validatePrompt="false"
      @customValueChanged="optionValueChanged"
    ></populate-form>
    <div class="tooltip-wrapper" v-b-tooltip.hover title="選完分店與課程方可操作">
      <b-button @click.prevent="showCreate" :disabled="SelectNotDone" >快速建立預約排程</b-button>
      <b-link href="/" target='_blank'>快速前往分店後台</b-link>
    </div>
    <b-modal 
      id="createModal"
      ref="createModal"
      size="lg"
      v-model="modalShow"
      centered
      hide-header
      hide-footer
      @hide="closeCheck"
      @shown="setFocus"
    >
      <!--非原生b-form-input的子組件的v-model綁定均須要額外的接收CB來更新值-->
      <populate-form
        formTitle="以日模板建立預約排程"
        fkey="sm02"
        ref="editForm"
        populateOptionVar="createOptions"
        formDataObjVar="formData"
        :validatePrompt="true"
        :parentVue="this"
      />
      <div class="dayplot-container">
        <div class="dayplot-inputrow" @keyup.enter="addToPlotList" @keypress="validatePlotInput">
          <b-form-input ref="InputPlotStr" v-model="InputPlotStr" placeholder="輸入HHMM後Enter加入模板列表"></b-form-input>
          <b-alert class="time-input-alert" dismissible fade variant="danger" :show="dismissCountDown" @dismissed="dismissCountDown=0" ><span>輸入的時間格式不符</span></b-alert>
          <b-alert class="time-input-alert" dismissible fade variant="danger" :show="dismissCountDown2" @dismissed="dismissCountDown2=0" ><span>此時段已經有了</span></b-alert>
        </div>
        <ul class="dayplots-list">
          <li class="col-10"
            v-for="(plot, index) in tmpDayPlots" :key="index"
          >{{plot.HH}}:{{plot.MM}}<span style="float:right;cursor:pointer;"  @click="removePlot(index)"><font-awesome-icon fixed-width size="lg" :icon="['far','trash-alt']" /></span></li>
        </ul>
      </div>
      <b-form-row class="col-md-12">
        <div class="tooltip-wrapper col-md-6" v-b-tooltip.hover title="全部填完且至少一個時段才可按">
          <b-button @click.prevent.stop="createSchedule" variant="primary" :disabled="readySend">確認</b-button>
        </div>
        <div class="tooltip-wrapper col-md-6" >
          <b-button @click.prevent.stop="cancelCreation" variant="danger">取消</b-button>
        </div>
      </b-form-row>
    </b-modal>
  </div>
</template>

<script>
import {
  apiGetMerchantAutoComplete,
  apiGetMerchantList 
} from '@/api/AdminManage.js'

export default {
  name: 'TemplateSchedule',
  components: {
    
  },
  data: function () {
    return {
      datePicketOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
      },
      dismissSecs: 1,
      dismissCountDown: 0,
      dismissCountDown2: 0,
      modalShow: false,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      CachedMerchant: Object, //用merchant_id當key的merchant_info cache
      CachedLoginStores: Object, //用merchant_store_id當key的merchant_store login cache
      Stores: [],
      SelectedStoreId: null,
      Services: [],
      SelectedServiceId: null,
      tmpDayPlots: [],
      InputPlotStr: '',
      formDataObj: {},
      filterOptions: [
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'asyncFetchCB': this.loadMerchantByKeyword,
          //'asyncMS': 500,
          'defaultValue':null,
          'akey':'SelectedMerchant',
          'optionLabel':'merchant_full_name',
          'col':12,
          'label':'',
          'placeholder':'選擇商家(名稱關鍵字)',
          'title':'',
          'validatePromptHint':'輸入選擇一下唄',
          'isRequired':true
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Stores',
          'defaultValue':null,
          'akey':'SelectedStore',
          'optionLabel':'store_name',
          'col':12,
          'label':'',
          'placeholder':'請再選擇分店',
          'title':'',
          'isRequired':true,
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Services',
          'defaultValue':null,
          'akey':'SelectedService',
          'optionLabel':'service_name',
          'col':12,
          'label':'',
          'placeholder':'請再選擇服務',
          'title':'',
          'isRequired':true,
        },
      ],
      formData: {},
      createOptions: [
        {
          'componentType':'date-picker',
          'datePickerConfig':{
            'format': 'YYYY/MM/DD',
          },
          'selectOptions':null,
          'defaultValue':'',
          'title':'排程起始日',
          'placeholder':'排程起始日',
          'akey':'schedule_start_date',
          'col':6,
          'label':'',
          'validatePromptHint':'請輸入有效日期',
          'isRequired':true
        },
        {
          'componentType':'date-picker',
          'datePickerConfig':{
            'format': 'YYYY/MM/DD',
          },
          'selectOptions':null,
          'defaultValue':'',
          'title':'排程結束日',
          'placeholder':'排程結束日',
          'akey':'schedule_end_date',
          'col':6,
          'label':'',
          'validatePromptHint':'請輸入有效日期',
          'isRequired':true
        },
        {
          'componentType':'number',
          'selectOptions':null,
          'defaultValue':'1',
          'title':'每時段人次數',
          'placeholder':'每時段人次數',
          'akey':'default_quota_per_plot',
          'col':6,
          'label':'',
          'validatePromptHint':'至少1人',
          'isRequired':true
        },
        {
          'componentType':'text',
          'selectOptions':null,
          'defaultValue':'SPA99',
          'title':'設定私人預約',
          'placeholder':'設定私人預約',
          'akey':'initial_reserve_remark',
          'col':6,
          'label':'',
          'validatePromptHint':'不能空白啦',
          'isRequired':true
        },
      ]
    }
  },
  props: [

  ],
  methods: {
    parseTemplateData () {
      // 把tmpDayPlots掃一遍組成字串回傳
      let templstr = ""
      for (let i=0;i<this.tmpDayPlots.length;i++) {
        templstr += "@|#"+this.tmpDayPlots[i].time
      }
      return templstr.substr(3)

    },
    addToPlotList () {
      const plot = {
        // 'index': this.tmpDayPlots.length+1,
        'HH': this.InputPlotStr.substr(0,2),
        'MM': this.InputPlotStr.substr(2,2),
        'time': this.InputPlotStr
      }
      if (plot.HH > '24' || plot.MM > '60') {
        this.InputPlotStr = ""
        this.dismissCountDown = this.dismissSecs
        this.$refs.InputPlotStr.focus()
        return
      }
      //再檢查重複
      for (let i=0;i<this.tmpDayPlots.length;i++) {
        if (this.tmpDayPlots[i].time === this.InputPlotStr) {
          this.dismissCountDown2 = this.dismissSecs
          this.$refs.InputPlotStr.focus()
          return
        }
      }
      this.tmpDayPlots.push(plot)
      // 要用時間排序
      this.tmpDayPlots.sort((a,b) => (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0));
      // 最後還要把輸入字串清空並再focus方便連續輸入
      this.InputPlotStr = ""
      this.$refs.InputPlotStr.focus()
    },
    removePlot (index) {
      this.tmpDayPlots.splice(index, 1)
      // 重新處理tmpDayPlots,重算index(才能再刪除)
      this.tmpDayPlots.sort((a,b) => (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0));
    },
    validatePlotInput(evt) {
      if (this.InputPlotStr.length >= 4) {
        evt.preventDefault()
        return
      }
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true;
      }
    },
    loadMerchants () {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':'',
      }
      // let vm = this
      // apiGetMerchantList(Param).then(function(resp){
      //   let data = resp.data
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.Merchants = data.data
      // })
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Merchants = data.data
      },this)
    },
    loadMerchantByKeyword (keyword) {

      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        this.$refs.filterForm.refreshModelVar('SelectedMerchant')
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      // let vm = this
      // apiGetMerchantAutoComplete(Param).then(function(resp){
      //   let data = resp.data
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   vm.Merchants = data.data.matched_merchant_list
      //   // 需要reset option
      //   vm.$refs.filterForm.refreshModelVar('SelectedMerchant')
      // })
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Merchants = data.data.matched_merchant_list
          // 需要reset option
          vm.$refs.filterForm.refreshModelVar('SelectedMerchant')
      },this)
    },
    changeMerchant(merchant) {
      if (merchant) {
        this.SelectedMerchantId = merchant.merchant_id
      }
      else {
        this.SelectedMerchantId = null
      }
      setTimeout(() => {
        this.loadMerchantById()
      }, 100);
    },
    changeStore() {
      // 直接呼叫載入選定的商家會失敗...囧
      setTimeout(() => {
        this.simulateStoreLogin()
      }, 400);
    },
    loadMerchantById() {
      if (this.SelectedMerchantId == null) {
        this.Stores = []
        this.SelectedStoreId = null
        this.Services = []
        this.SelectedServiceId = null
        // 重設要呼叫這個方法,主要是清select的localValue
        this.$refs.filterForm.refreshModelVar('SelectedStore,SelectedService')
        return
      }
      // 回到預設
      this.Stores = []
      this.SelectedStoreId = null
      this.Services = []
      this.SelectedServiceId = null
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+this.SelectedMerchantId)) {
        this.SelectedMerchant = this.CachedMerchant['m_'+this.SelectedMerchantId]
        this.Stores = this.SelectedMerchant.merchant_stores
        // 課程目前階段有兩層,需要先處理再產生下拉選單數據
        let services = []
        for (let i=0;i<this.SelectedMerchant.merchant_ticket_projects.length;i++) {
          let item = {
              ticket_project_service_item_id:this.SelectedMerchant.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
              service_name:this.SelectedMerchant.merchant_ticket_projects[i].ticket_services[0].service_name,
              product_id:this.SelectedMerchant.merchant_ticket_projects[i].product_id
          }
          services.push(item)
        }
        this.Services = this.CpObj(services)
        // 需更新filterForm的select類的options時需要另外呼叫,options屬性裡直接綁對應data參考碰到動態選項時會沒用
        this.$refs.filterForm.refreshModelVar('SelectedStore,SelectedService')
      }
      else {
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':this.SelectedMerchantId,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.SelectedMerchant = vm.CpObj(data.data)
            vm.Stores = data.data.merchant_stores
            let services = []
            for (let i=0;i<vm.SelectedMerchant.merchant_ticket_projects.length;i++) {
              let item = {
                  ticket_project_service_item_id:vm.SelectedMerchant.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
                  service_name:vm.SelectedMerchant.merchant_ticket_projects[i].ticket_services[0].service_name,
                  product_id:vm.SelectedMerchant.merchant_ticket_projects[i].product_id
              }
              services.push(item)
            }
            vm.Services = vm.CpObj(services)
            vm.CachedMerchant['m_'+vm.SelectedMerchantId] = data.data
            // 動態選項都要手動呼叫更新
            vm.$refs.filterForm.refreshModelVar('SelectedStore,SelectedService')
        },this)
      }
    },
    simulateStoreLogin () {
      // 模擬登入(外加cache)
      if (this.SelectedStoreId === null) {
        // 不用清掉當前的模擬商家登入localstorage
        return
      }
      // 先找Cache,若剛剛登入過就重用之前的login session就好
      if (this.CachedLoginStores.hasOwnProperty('s_'+this.SelectedStoreId)) {
        // 切換merchant_session即可
        const session_key = 'merchant_session'
        window.localStorage.setItem(session_key, JSON.stringify(this.CachedLoginStores['s_'+this.SelectedStoreId]))
      }
      else {
        let Param = {
          'module': 'admin_manage',
          'method': 'simulateMerchantStoreLogin',
          'merchant_store_id': this.SelectedStoreId,
        }
        this.$bus.apiCall(Param, function (data, vm) {
            if (data.ok === 0) {
                vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                return
              }
            const session_key = 'merchant_session'
            window.localStorage.setItem(session_key, JSON.stringify(data.data))
            vm.CachedLoginStores['s_'+data.data.merchant_store_id] = data.data
          },this)
      }
    },
    showCreate () {
      // 這樣重設default是ok的
      this.formData = {
        schedule_start_date: null,
        schedule_end_date: null, 
        default_quota_per_plot: '1',
        initial_reserve_remark: 'SPA99'
      }
      setTimeout(() => {
        this.modalShow = true
      }, 100);
    },
    createSchedule(evt) {
      if (this.tmpDayPlots.length == 0) {
        this.$bus.fnShowInfo('至少需要建立一個時段')
        evt.preventDefault()
        return
      }
      // 用選定的分店+服務批次建立
      let Param = {
          'module':'reservation',
          'method':'createScheduleByTemplate',
          'role':'merchant',
          'merchant_store_id':this.SelectedStoreId,
          'ticket_project_service_item_id':this.SelectedServiceId,
          'schedule_start_date':this.formData.schedule_start_date,
          'schedule_end_date':this.formData.schedule_end_date,
          'default_quota_per_plot':this.formData.default_quota_per_plot,
          'initial_reserve_remark':this.formData.initial_reserve_remark,
          'template_date_data':this.parseTemplateData()
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              // 這頁的modal不關起來這個全域的modal info會彈不出來
              // 所以這個bus裡的modal僅限不在打開組件內部modal狀態下使用
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg,false,
                // 顯示完錯誤訊息後把填寫的popup再彈回來= =
                function() {
                  vm.$bus.fnClosePopup()
                  vm.modalShow = true 
                }
              )
              vm.modalShow = false
              return
            }
            vm.modalShow = false
            vm.$bus.fnShowInfo('建立完畢請至商家介面')
            setTimeout(() => {
              vm.cancelCreation()
            }, 200);
        },this)
    },
    closeCheck: function (evt) {
      if (this.modalShow) {
        evt.preventDefault()
      }
    },
    setFocus () {

    },
    cancelCreation () {
      // 把表單已填內容清除
      this.formData.schedule_start_date = null
      this.formData.schedule_end_date = null
      this.formData.default_quota_per_plot = 1
      this.formData.initial_reserve_remark = 'SPA99'
      this.tmpDayPlots = []
      this.modalShow = false
    },
    optionValueChanged(upd) {
      if (upd.key === 'SelectedMerchant') {
        this.SelectedMerchantId = upd.val?upd.val.merchant_id:null
        this.changeMerchant(upd.val)
      }
      else if (upd.key === 'SelectedStore') {
        this.SelectedStoreId = upd.val?upd.val.id:null
        // 還要simulate login才行
        this.changeStore()
      }
      else if (upd.key === 'SelectedService') {
        this.SelectedServiceId = upd.val?upd.val.ticket_project_service_item_id:null
      }
    },
  },
  computed: {
    SelectNotDone () {
      return (this.SelectedStoreId === null || this.SelectedServiceId === null)
    },
    readySend: {
      cache: false,
      get () {
        if (  this.formData.schedule_start_date &&
              this.formData.schedule_end_date &&
              this.formData.default_quota_per_plot &&
              this.formData.initial_reserve_remark &&
              this.tmpDayPlots.length > 0
        ) {
          return false
        }
        else {
          return true
        }
      }
    },
  },
  created: function () {
    
  },
  mounted () {
    this.$off('modal-template-create-close')
    this.$on('modal-template-create-close', function () {
      this.modalShow = false
    }.bind(this))
    // 有populate form且formDataObjVar對應的物件data沒有初始化時需要呼叫這個方法初始化
    this.$refs.filterForm.initDefault()
  },
  watch:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tooltip-wrapper {
  display: inline-block;
}
.tooltip-wrapper >>> b-button {
  pointer-events: none;
}
.dayplot-container {
  width:100%;
  border-style: inset;
  margin-top:10px;
}
.dayplot-inputrow {
  margin-left:auto;
  margin-right:auto;  
  width:240px;
}
.dayplots-list {
  margin-left:auto;
  margin-right:auto;
  width: 90%;
  height: 300px;
  overflow-y: scroll;
}
/*following two makes ios fix show scrollbar when not in scrolling*/
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
.dayplots-list >>> li {
  height:40px;
  margin: 1px;
  padding-top: 8px;
  background-color: bisque;
}
.time-input-alert {
  width:300px;
  float:right;
}
</style>
